import { IMAGE_PLACEHOLDER } from "../components/SmartImage";

/**
 * Get the image source URL for a submission
 * Prioritizes B2/CDN URL, falls back to base64, then a local placeholder.
 *
 * @param {Object} submission - The submission object
 * @param {string} fallbackUrl - Optional fallback URL if no image available
 * @returns {string} Image source URL
 */
export const getSubmissionImageSrc = (submission, fallbackUrl = null) => {
  if (!submission) {
    return fallbackUrl || IMAGE_PLACEHOLDER;
  }

  // Priority 1: B2/CDN URL (new system)
  if (submission.image_url) {
    return submission.image_url;
  }

  // Priority 2: Base64 (legacy system)
  if (submission.image_base64) {
    return `data:image/jpeg;base64,${submission.image_base64}`;
  }

  // Fallback (local placeholder, no external dependency)
  return fallbackUrl || IMAGE_PLACEHOLDER;
};

/**
 * Check if a submission has an image
 * @param {Object} submission - The submission object
 * @returns {boolean}
 */
export const hasSubmissionImage = (submission) => {
  return !!(submission?.image_url || submission?.image_base64);
};

/**
 * Get the anonymous ID for jury display
 * @param {Object} submission - The submission object
 * @returns {string}
 */
export const getAnonymousId = (submission) => {
  return submission?.anonymous_id || `IMG-${submission?.id?.slice(0, 8) || 'UNKNOWN'}`;
};
